export default "__VITE_ASSET__9e07d519__"